import { ConcreteEncodable } from "./ConcreteEncodable";

import { QueryGroupImplEncoder } from "../../encoder/QueryGroupImplEncoder";

import * as CubiqTS from "../../index";
import { QueryGroup } from "../QueryGroup";

export class QueryGroupImpl extends ConcreteEncodable implements QueryGroup {
  public static enType: string = "com.bcdfx.model.query.QueryGroupImpl";

  /*FID=1*/
  public condition: CubiqTS.Condition;
  /*FID=2*/
  public groups: Array<any> | null = null;
  /*FID=3*/
  public rules: Array<any> | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = QueryGroupImplEncoder.Instance;
    this.setEncodableType(QueryGroupImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "QueryGroupImpl[" +
      "condition=" +
      this.condition +
      "groups=" +
      this.groups +
      "rules=" +
      this.rules +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
